import FlexRow from "@/components/FlexRow.vue";
import { TextValue } from "@/components/tableElements";
import HighlightTextValue from "@/components/tableElements/HighlightTextValue.vue";
import { WrapWithSectionItem } from "../sections";
export default {
  name: "CategoryFilterItem",
  emits: ["select", "selectOnly", "deselect"],
  props: {
    category: String,
    id: String,
    selected: Boolean,
    // Search term to highlight within the label.
    query: {
      type: String,
      default: ""
    }
  },
  components: {
    WrapWithSectionItem,
    TextValue,
    HighlightTextValue,
    FlexRow
  }
};